import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Contact } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { LeadDetail } from "@/features/crm/lead-detail";

function LeadDetailPage() {
  const { t } = useI18n();
  const params = leadDetailRoute.useParams();
  return (
    <PageContainer maxWidth="5xl">
      <PageHeader title={t(msg`Lead`)} icon={Contact} backTo="/crm" />
      <div class="mt-4">
        <LeadDetail leadId={params().leadId} />
      </div>
    </PageContainer>
  );
}

export const leadDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm/leads/$leadId",
  component: withFeatureGate("crm.leads", LeadDetailPage),
});
